@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.linkedAccounts {
  padding-bottom: 20px;
}

.linkedAccount {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  height: 64px;
  width: 100%;

  .avatar {
    display: flex;
    width: 50px;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 64px;
  }

  .icon {
    position: absolute;
    right: -5px;
    bottom: 0;

    svg {
      display: block;
    }
  }

  .detailsContainer {
    position: relative;
    display: flex;
    padding: 10px 0;
    justify-content: space-between;
    align-items: center;
    flex: 1 0 0;
    border-bottom: 1px solid var(--Dark-4, rgba(0, 0, 0, 0.04));
    height: 64px;
    min-width: 0;
  }

  .details {
    position: relative;
    display: flex;
    padding: 10px 0;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 2px;
    flex: 1 0 0;
    height: 64px;
    min-width: 0;
  }

  :global(.ant-skeleton-content) {
    border-bottom: 1px solid var(--Dark-4, rgba(0, 0, 0, 0.04));
  }
}
